import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type LoginRequest = {
  email: string;
  password: string;
  bizsol_sub?: string;
};

type LoginResponse = {
  token: string;
  session: string;
  is_first_login: boolean;
  two_factor_enabled: boolean;
};

type LoginErrorResponse = {
  email: string[];
  password: string[];
  messages: string[];
};

export type TwoFactorCodeRequest = {
  email: string;
  password: string;
};

type TwoFactorCodeResponse = {
  challenge: string;
  session: string;
  destination: string;
};

type TwoFactorCodeErrorResponse = {
  email: string[];
  code: string[];
  session: string[];
  messages: string[];
};

export type ConfirmTwoFactorCodeRequest = {
  email: string;
  session: string;
  code: string;
};

type ConfirmTwoFactorCodeResponse = {
  message: string;
};

export const companyLoginApiClient = {
  login: async (params: LoginRequest): Promise<ApiResult<LoginResponse, LoginErrorResponse>> => {
    return await axiosClient.post('/company/auth/login', params);
  },

  requestTwoFactorCode: async (
    params: TwoFactorCodeRequest,
  ): Promise<ApiResult<TwoFactorCodeResponse, TwoFactorCodeErrorResponse>> => {
    return axiosClient.post('/company/two-factor/code', params);
  },

  /** 2段階認証コード検証（OTP 確認） */
  confirmTwoFactorCode: async (
    params: ConfirmTwoFactorCodeRequest,
  ): Promise<ApiResult<ConfirmTwoFactorCodeResponse, TwoFactorCodeErrorResponse>> => {
    return axiosClient.put('/company/two-factor/code', params);
  },
};
